import { controls } from "../controls";

const hrms_home = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  dashboard: [
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),
    // {
    //   widths: "col-lg-4 col-md-6 col-sm-12",
    //   tab: "create",
    //   theme: "orotheme",
    //   title: "Getting Started icon-selfWhatsApp",
    //   footer: "KYC Information",
    //   selfWhatsApp: "sendsummary",
    //   subComponents: [
    //     ...controls.kpiList({
    //       name: "kpi_list1",
    //       values: [
    //         { main: { desc: "Name", url: "bank", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Age", value: "13", color: "#8af07f" } },
    //         { main: { desc: "Address", value: "13", color: "#8af07f" } },
    //         { main: { desc: "Contact", url: "branches", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Email", url: "rbi_mis_nos", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Designation", url: "gls", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Role in System", url: "groups", value: "icon-cross", color: "#ff4646" } },
    //       ]
    //     }),
    //   ]
    // },


    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "Payroll icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "As of last month",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Pay Slip", url: "gls", value: "icon-download" } },
            { main: { desc: "Deductions", url: "gls", value: "icon-download" } },
            { main: { desc: "TDS Certificate", url: "gls", value: "icon-download" } },
            { main: { desc: "Form 16", url: "gls", value: "icon-download" } },
            { main: { desc: "Joining Documents", url: "gls", value: "" } },
            { main: { desc: "Manage Investments", url: "gls", value: "" } },
          ]
        }),
      ]
    },

    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      // theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "Help Desk icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Leave Application", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Deduction Request", url: "gls", value: "", color: "green" } },
            { main: { desc: "Request Reimbursement", url: "gls", value: "", color: "green" } },
            { main: { desc: "Correction Request", url: "gls", value: "", color: "green" } },
            { main: { desc: "New Certification", url: "gls", value: "", color: "green" } },
            { main: { desc: "Transfer Request", url: "gls", value: "", color: "green" } },
            { main: { desc: "Department Change Request", url: "gls", value: "", color: "green" } },
            { main: { desc: "Apply Loan", url: "gls", value: "", color: "green" } },
            { main: { desc: "Apply Advance", url: "gls", value: "", color: "green" } },
            { main: { desc: "Special Request", url: "gls", value: "", color: "green" } },
          ]
        }),
      ]
    },
    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      title: "Notifications icon-selfWhatsApp",
      footer: "To be generated from Finacle",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Accept Target", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Upload Training Certificate", url: "upload_trial_balances", value: "icon-tick", color: "green" } },
            { main: { desc: "Acknowledge Circulars", url: "gls", value: "icon-tick", color: "green" } },
          ]
        }),
      ]
    },
    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "Leaves icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "As of today",
      subComponents: [
        ...controls.kpiTable({
          name: "leaves",
          values: [
            ["Type", "Remaining", "Pending", "Paid"],
            ["Medical", "12", "12", "0"],
            ["Privilege", "12", "3", "0"],
            ["Casual", "12", "12", "0"],
            ["Extra", "0", "0", "0"]
          ]
        }),
      ]
    },


    // {
    //   widths: "col-lg-4 col-md-6 col-sm-12",
    //   tab: "create",
    //   selfWhatsApp: "sendsummary",
    //   title: "Leaves Consumption icon-selfWhatsApp",
    //   // style:{border:"none"},
    //   footer: "for the current financial year",
    //   subComponents: [
    //     ...controls.gchart({
    //       charttype: "pie"
    //     }),
    //   ]
    // },

    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Events icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "As of today",
      subComponents: [
        ...controls.kpiTable({
          name: "leaves",
          values: [
            ["Name", "Mobile", "Event"],
            ["Amrutraj Gore", "8380006707", "BIRTHDAY"],
            ["Sunil Lagoo", "8670006707", "BIRTHDAY"],
            ["Rohan Dhadde", "6760006707", "BIRTHDAY"],
            ["Satish Mehta", "7784787393", "RETIREMENT"],
          ]
        }),
      ]
    },

    {
      widths: "col-lg-4 col-md-6 col-sm-12",
      tab: "create",
      title: "Employee Welfare icon-selfWhatsApp",
      footer: "Added discounts offered by the bank and vendors.",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Health Insurance", url: "gls", value: "", color: "green" } },
            { main: { desc: "Investments", url: "upload_trial_balances", value: "", color: "green" } },
            { main: { desc: "Credit Cards", url: "gls", value: "", color: "green" } },
          ]
        }),
      ]
    },
  ]
};

export default hrms_home;